<script>
import Checkbox from 'primevue/checkbox';
import InputText from 'primevue/inputtext';

export default {
  components: {InputText, Checkbox},
  inject: {pSubmitted: {default: null}, pDisabled: {default: null}},
  props: {
    label: {
      type: String,
      required: false,
      default: undefined,
    },
    modelValue: {
      required: true,
    },
    value: {
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: undefined,
    },
    className: {
      type: String,
      required: false,
      default: '',
    },
    submitted: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    binary: {
      type: Boolean,
      required: false,
      default: true,
    },
    labelClass: {
      type: String,
      required: false,
      default: 'font-semibold text-grey-900 text-base',
    },
    validator: {
      type: Object,
      required: false,
      default: undefined,
    },
    requiredMessage: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      id: null,
    };
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
    alreadySubmitted() {
      if (this.submitted !== undefined) return this.submitted;
      if (this.pSubmitted !== undefined) return this.pSubmitted;
      return false;
    },
    getPlaceholder() {
      return this.placeholder ? this.placeholder : this.label;
    },
    isDisabled() {
      if (this.disabled !== undefined) return this.disabled;
      if (this.pDisabled !== undefined) return this.pDisabled;
      return false;
    },
    hasValidator() {
      return this.validator !== undefined;
    },
    isRequiredFailed() {
      return this.validator?.checked?.$invalid && this.alreadySubmitted;
    },
  },
  mounted() {
    this.id = 'id_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  },
  methods: {
    change(event) {
      this.$nextTick(() => {
        this.$emit('change');
      });
    },
  },
};
</script>

<template>
  <div :class="className" class="form-group">
    <div class="flex items-center gap-2" :class="[{'p-invalid': isRequiredFailed && alreadySubmitted}]">
      <Checkbox
        :inputId="id"
        v-model="currentValue"
        :disabled="disabled"
        :binary="binary"
        class="form-check-input"
        :value="value"
        @change="change($event)" />
      <label class="flex-1 font-inter" :class="[this.labelClass, {'cursor-pointer': !disabled}]" :for="id">
        <template v-if="this.label">{{ this.label }}</template>
        <slot name="label"></slot>
      </label>
    </div>
    <div class="flex flex-col flex-1">
      <small v-if="isRequiredFailed" class="p-error">
        {{ this.requiredMessage }}
      </small>
    </div>
  </div>
</template>
